module.exports = __webpack_public_path__ + "assets/images/mobile-app-preview/iphone.02d57380040a77658caaae9b30fdafbf.webp";